import Vue from 'vue'

declare global {
	interface Window {
		RESOURCE_HOST: any
		COPYRIGHT: any
		SCHOOL: any
	}
}

const env = {
	RESOURCE_HOST: window.RESOURCE_HOST,
	COPYRIGHT: window.COPYRIGHT,
	SCHOOL: window.SCHOOL,
}

// Vue.env = env
Vue.prototype.$env = env

export default env
